import { PLANT_STATUS } from './plants.schema.ts';

export type TPlantStatus = (typeof PLANT_STATUS)[number];

export const getLabelPlantStatus = (status: TPlantStatus) => {
  const map: Record<TPlantStatus, 'green' | 'blue' | 'yellow' | 'gray'> = {
    Operational: 'green',
    Planning: 'blue',
    'Under Construction': 'yellow',
    Maintenance: 'yellow',
    Archived: 'gray',
  };
  return map[status] ?? 'gray';
};

export function getCompactPlantStatus(status: TPlantStatus, isMobile: boolean) {
  if (!isMobile) return status;
  const words = status.split(' ');
  if (words.length <= 1) return status;
  return `${words[0][0].toUpperCase()} ${words.slice(1).join(' ')}`;
}
